import {remCalc} from '../../_utils'

export default {
    baseStyle: ({shouldHideVariants}: {shouldHideVariants: boolean}) => ({
        container: {
            boxSizing: 'border-box',
            position: 'relative',
            paddingTop: {base: remCalc(0), lg: remCalc(16)},
            paddingX: {base: remCalc(0), lg: remCalc(16)},
            paddingBottom: remCalc(24),
        },
        favIcon: {
            position: 'absolute',
            variant: 'unstyled',
            top: remCalc(16),
            right: remCalc(16),
            boxSize: 'iconsSize.medium',
            minWidth: 'auto',
        },
        favSvg: {
            boxSize: 'iconsSize.medium',
            color: 'background.dark',
        },
        favSvgSolid: {
            boxSize: 'iconsSize.medium',
            color: 'background.alternative',
        },
        stockLabelContainer: {
            marginBottom: remCalc(16),
        },
        category: {
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
            fontWeight: 'bold',
            marginBottom: remCalc(16),
            textTransform: 'uppercase',
        },
        title: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            noOfLines: 3,
            fontWeight: 'medium',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxW: {base: remCalc(189), md: remCalc(168), lg: remCalc(176)},
        },
        sku: {
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'bold',
        },
        imageWrapper: {
            position: 'relative',
            marginBottom: {base: remCalc(30), lg: remCalc(24)},
        },
        titlePriceWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: remCalc(20),
            gap: {
                base: remCalc(52),
                md: remCalc(27),
                lg: remCalc(24),
            },
        },
        titleWrapper: {
            alignItems: 'start',
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        priceWrapper: {
            alignItems: 'end',
            textAlign: 'right',
            gap: remCalc(12),
            maxWidth: remCalc(120),
        },
        listPrice: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        currentPrice: {
            color: 'text.default',
            textStyle: 'body-large',
            fontWeight: '400',
        },
        image: {
            ratio: 1,
        },
        imageOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'background.image',
        },
        imageThumbnailOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            my: remCalc(10),
            _hover: {
                backgroundColor: 'background.image',
            },
        },
        badgeGroup: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            maxWidth: '100%',
            flexWrap: 'wrap',
        },
        energyLabel: {
            marginBottom: remCalc(20),
        },
        reviewCompareWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingBottom: shouldHideVariants ? 'unset' : {base: remCalc(14), lg: remCalc(24)},
            flexWrap: 'wrap',
        },
        swatchThumbnailWrapper: {
            _hover: {
                borderBottom: 'small',
                borderStyle: 'solid',
            },
        },
        swatchThumbnail: {
            width: remCalc(48),
            height: remCalc(48),
        },
        swatchContainer: {
            marginBottom: {base: remCalc(10), lg: remCalc(4)},
        },
        variantsLabel: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        divider: {
            marginBottom: remCalc(24),
        },
        featureList: {
            textStyle: 'body-small',
            marginBottom: remCalc(24),
        },
        featureListElement: {
            mt: remCalc(8),
        },
        buttonGroup: {
            display: 'grid',
            width: '100%',
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        reviews: {
            width: 'fitContent',
        },
    }),
    variants: {
        transparent: {
            imageOverlay: {
                backgroundColor: 'unset',
            },
            imageWrapper: {
                marginBottom: {base: remCalc(8), lg: remCalc(16)},
                borderRadius: remCalc(4),
                overflow: 'hidden',
            },
            badgeGroup: {
                position: 'absolute',
                bottom: remCalc(17),
                left: remCalc(21),
            },
        },
        compact: {
            container: {
                paddingBottom: remCalc(16),
            },
            badgeGroup: {
                position: 'relative',
                display: 'grid',
                width: '100%',
                gap: remCalc(5),
                paddingTop: remCalc(18),
            },
            stockLabelContainer: {
                marginBottom: remCalc(18),
            },
            titleWrapper: {
                gap: remCalc(18),
            },
            titlePriceWrapper: {
                display: 'grid',
                gap: remCalc(18),
                marginBottom: remCalc(18),
            },
            reviewCompareWrapper: {
                display: 'grid',
                gap: remCalc(24),
                paddingBottom: remCalc(18),
            },
            compare: {
                marginRight: 'auto',
            },
            energyLabel: {
                marginBottom: remCalc(18),
            },
            priceWrapper: {
                alignItems: 'start',
                textAlign: 'left',
            },
            imageWrapper: {
                position: 'relative',
                display: 'grid',
                marginBottom: remCalc(18),
            },
            image: {
                ratio: 1,
            },
            variantsLabel: {
                marginBottom: remCalc(18),
            },
            divider: {
                marginBottom: remCalc(18),
            },
            category: {
                marginBottom: remCalc(18),
            },
        },
        bundle: {
            badgeGroup: {
                display: 'none',
            },
            image: {
                ratio: 85 / 95,
            },
            imageOverlay: {
                backgroundColor: 'unset',
            },
            imageWrapper: {
                position: 'relative',
                marginBottom: 'unset',
                w: {base: remCalc(85), lg: '100%'},
                h: {base: remCalc(95), lg: '100%'},
                mx: {base: remCalc(8), lg: 0},
                my: {base: remCalc(4), lg: 0},
                padding: {base: 0, lg: remCalc(24)},
                paddingBottom: {base: remCalc(4), lg: remCalc(30)},
                alignSelf: ['center', 'center', 'center', 'unset'],
            },
        },
        freeItemPromo: {
            imageWrapper: {
                width: '100%',
            },
        },
        collapsable: ({isHovered}: {isHovered: boolean}) => ({
            container: {
                borderTop: 'small',
                borderLeft: 'small',
                borderRight: 'small',
                borderColor: isHovered ? 'border.light' : 'transparent',
                borderStyle: 'solid',
                shadow: isHovered && 'borderShadow',
            },
            collapsableSection: {
                boxSizing: 'content-box',
                paddingTop: remCalc(0),
                paddingBottom: remCalc(18),
                paddingX: remCalc(16),
                width: '100%',
                position: 'absolute',
                bottom: 0,
                left: remCalc(-17),
                transform: 'translateY(100%)',
                backgroundColor: 'white',
                shadow: 'borderShadowBottom',
                zIndex: 3,
                borderBottom: 'small',
                borderLeft: 'small',
                borderRight: 'small',
                borderColor: 'border.light',
                borderStyle: 'solid',
            },
            swatchContainer: {
                visibility: isHovered ? 'visible' : 'hidden',
            },
            variantsLabel: {
                visibility: isHovered ? 'hidden' : 'visible',
            },
            divider: {
                marginTop: remCalc(0),
            },
        }),
    },
    parts: [
        'container',
        'imageWrapper',
        'image',
        'imageOverlay',
        'price',
        'reviewCompareWrapper',
        'title',
        'rating',
        'energyLabel',
        'sku',
        'category',
        'stockLabelContainer',
        'variations',
        'badgeGroup',
        'swatchContainer',
        'link',
        'compare',
        'divider',
        'variantsLabel',
        'titlePriceWrapper',
        'collapsableSection',
        'titleWrapper',
        'priceWrapper',
        'bodyWrapper',
        'hovered',
        'imageContainer',
    ],
}
